module.exports = __webpack_public_path__ + "static/media/webdevelopment.5044486f.gif";